import styled from "styled-components";

export const Card = styled.a`
    display: flex;
    position: relative;
    flex-direction: column;
    background: #fff;
    border-radius: 35px;
    padding: 25px 25px;
    text-decoration: none;
    color: #2770d8;
    height: 290px;
    width: 590px;

    @media (max-width: 640px) {
        height: 250px;
        width: 80vw;
    }
`;

export const ReviewHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    flex-direction: row;
    height: 48px;
`;

export const ReviewHeaderDate = styled.div`
    font-weight: 400;
    font-size: 24px;
    line-height: 30px;
    @media (max-width: 1240px) {
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
    }
`;

export const ReviewText = styled.div`
    font-family: "TT Commons Pro", sans-serif;
    font-weight: 300;
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    padding-right: 60px;

    @media (max-width: 1240px) {
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
    }
`;

export const ReviewContent = styled.div`
    display: flex;
    height: 100%;
    gap: 20px;
    align-items: start;
    @media (max-width: 1240px) {
        flex-direction: column;
    }
`;

export const ReviewLogo = styled.img`
    height: ${(props: { imageHeight: string }) => props.imageHeight};
`;

export const ReviewLinkArrows = styled.img`
    position: absolute;
    right: 25px;
    bottom: 25px;
    height: 40px;
    width: 60px;
`;
